<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <br>
            <div class="text-center">
                <h2>บันทึกค่าเสียหาย</h2>
            </div>
            <br/>
            <div class="row" style="margin-left: 30px" >
                <div class="col-sm-6">
                    <span><b>ชื่อ</b> : {{driver.first_name}}</span>
                    <br/><br/>
                    <span><b>นามสกุล</b> : {{driver.last_name}}</span>
                    <br/><br/>
                    <span>
                    <b>เบอร์โทรศัพท์</b> :
                    <span>{{driver.phone}} , </span>
                </span>
                </div>
                <div class="col-sm-6">
                    <span><b>ทะเบียนรถ</b> : {{driver.license_plate}}</span>
                    <br/>
                </div>
            </div>

            <div class="text-right">
                <button class="btn btn-info" type="button" @click="printExcel(driver.id)">
                    <icon name="print"></icon>
                    พิมพ์ข้อมูล Excel
                </button>
            </div>
            <br>
            <div class="col-12 table-responsive">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">วัน/เดือน/ปี ที่จ่าย</th>
                        <th scope="col">หมายเหตุ</th>
                        <th scope="col">จำนวน</th>
                        <th scope="col">จำนวนคงเหลือ</th>
                        <th scope="col">ผู้ชำระ</th>
                        <th scope="col">ผู้รับเงิน</th>
                        <th scope="col" v-if="canViewSuperAdmin">ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in driverDamagesTable">
                        <td>{{data.date | moment("DD/MM/YYYY") }}</td>
                        <td>{{data.reason}}</td>
                        <td>
                            <template v-if="data.amount > 0">
                                <span style="color: green">+ {{data.amount ? data.amount : 0 | currency }}</span>
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>{{data.balance ? data.balance : 0  | currency }}</td>
                        <td>{{driver.name}}</td>
                        <td>{{data.recipient}}</td>
                        <td v-if="canViewSuperAdmin">
                            <a @click="showDeleteModal(data.id)">
                                <icon name="trash">
                                </icon>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <div v-if="driverDamagesTable.length > 0">
                    <vue-pagination :pagination="dataPaginate"
                                    @paginate="getPage">
                    </vue-pagination>
                </div>
            </div>
            <b-modal hide-header hide-footer ref="delete_item">
                <div style="text-align: center;">
                    <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                    <br />
                    <button
                        type="button"
                        class="btn btn-success"
                        @click="deleteItem">
                        ตกลง
                    </button>
                    &nbsp&nbsp
                    <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click="hideDeleteModal">
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
            <!--<pre class="alert alert-primary">{{ driverDamagesTable }}</pre>-->
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
    import VuePagination from "../../Pagination";
    import {domain} from "../../../util/Constants";
    import {canViewSuperAdmin} from "../../../util/Permissions";

    export default {
        components: {DeleteConfirmModal,VuePagination},
        name: "damages-information",
        data(){
          return{
              delete_id : null,
              items: [
                  {
                      text: "บันทึกค่าเสียหาย",
                      to: { name: "cost-damages" }
                  },
                  {
                      text: "เพิ่มเติม",
                      active: true
                  }
              ],
          }
        },
        created(){
            this.getPage();
        },
        computed:{
            canViewSuperAdmin,
            ...mapState({
                driver :state=>{
                    return state.Driver.form;
                },
                driverDamagesTable :state=>{
                    return state.Damages.damages_cost
                },
                dataPaginate:state=>{
                    return state.Damages.dataPaginate
                }
            })
        },
        methods:{
            getPage(){
                this.$store.dispatch("Damages/showDamages",{
                    driver_id : this.driver.id,
                    page : this.dataPaginate.current_page,
                })
            },
            printExcel(id){
                window.open(domain+'/damages-cost-excel?id='+id)
            },
            showDeleteModal(id){
                this.delete_id = id;
                this.$refs.delete_item.show();
            },
            hideDeleteModal(){
                this.$refs.delete_item.hide();
            },
            deleteItem(){
                this.$store.dispatch('Damages/deleteDamages',this.delete_id).then(()=>{
                    this.hideDeleteModal();
                    this.getPage();
                })
            }
        }
    }
</script>

<style scoped>
    thead{
        background-color: lightgray;
        color: black;
    }
    tbody{
        background-color: white;
        color: black;
    }
</style>
